import React, { Component } from 'react'

export default class AboutPage extends Component {
  render () {
    return (
      <div>
        AboutPage
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/AboutPage/AboutPage.js